import { SurveyModulesComponent } from 'component'
import Button from 'styled/Custom/Button'
import { Done as DoneIcon } from '@material-ui/icons'
import { useIntl } from 'react-intl'
import Question from 'styled/Survey/Question'
import Module from 'styled/Survey/Module'
import FileAndPictureComponent from '../Modules/FileAndPicture'

const Component = (props) => {
    const { _question, mbox, _option={required: false}, onPageNextOne } = props
    const { img_src, img_poster, img_position, img_name, confirm } = _question

    const { formatMessage: f } = useIntl()

    // 멀티일경우 무조건 포지션은 스택이다
    const _img_position = mbox.method === 'multi' ? 'stack' : img_position

    const isOneButton = typeof onPageNextOne === 'function' && mbox.method === 'one'

    const buttonMessage = confirm || f({id: 'component.Survey.Live.One.button'})

    return (
        <SurveyModulesComponent {..._question} required={_option.required} mbox={mbox} isOneButton={isOneButton}>
            <div className="question">
                <Question question={_question.question} mark_required={mbox.mark_required} />
            </div>
            <div className="line"></div>
            <div className="module">
                <Module {...props}/>
            </div>
            <div className="image">
                <FileAndPictureComponent
                    method={mbox.method} 
                    img_src={img_src}
                    img_position={_img_position} 
                    img_poster={img_poster}
                    img_name={img_name}
                />
            </div>
            <div className="oneButton">
                {isOneButton && <Button size="medium" startIcon={<DoneIcon/>} onClick={onPageNextOne}>{buttonMessage}</Button>}
            </div>
        </SurveyModulesComponent>  
    )
}

export default (Component)